import React, { Fragment, useState } from 'react';
import { H6, Image, P } from '../../../../AbstractElements';
import { Col, Nav, NavLink } from 'reactstrap';
import CreateContact from './CreateContact';

const ListNewContact = ({ eng, supervisors, userCallback }) => {
  const [dynamictab, setDynamicTab] = useState('0');

  const ContactDetails = (supervisor) => {
    userCallback({ position_name: supervisor.position_name, ministry_full_name: supervisor.ministry_full_name, id: supervisor.item_id, employee_id: supervisor.employee_id,firstname: supervisor.firstname, surname: supervisor.surname, avatar: "user/user.png", email_address: supervisor.email_address, cellphone_number: supervisor.cellphone_number });
  };

 

  return (
    <Fragment>
      <Col xl='4' md='5' className='xl-50'>
        <Nav tag='div' className='flex-column nav-pills'>
          {supervisors.length > 0 ? (
            supervisors.map((supervisor, index) => {
              return (
                <NavLink className={dynamictab === index ? 'active' : ''} onClick={() => setDynamicTab(index)} key={index}>
                  <div className='media' onClick={() => ContactDetails(supervisor)}>
                    <Image attrImage={{ className: 'p-0 img-fluid img-50 m-r-20 rounded-circle update_img_0', src: `${require(`../../../../assets/images/user/user.png`)}`, alt: '' }} />
                    <div className='media-body'>
                      <H6>
                        <span className='first_name_0'>{supervisor.firstname}</span>&nbsp;
                        <span className='last_name_0'>{supervisor.surname}</span>
                      </H6>
                      <P attrPara={{ className: 'email_add_0' }}>
                        {eng=='ps_approver'? supervisor.ministry_full_name : eng=='committee_approver'? supervisor.position_name : supervisor.email_address}
                        
                      </P>
                    </div>
                  </div>
                </NavLink>
              );
            })
          ) : (
            <div className='p-4'>
              You need to create new supervisors.Please click on button.
              <CreateContact empty={supervisors.length > 0 ? true : false}>
                <b>New Supervisor</b>
              </CreateContact>
            </div>
          )}
        </Nav>
      </Col>
    </Fragment>
  );
};

export default ListNewContact;
